export interface RoleType {
  id: string;
  key: string;
  name: string;
  role_type_class: string;
  is_admin: boolean;
  rank: number;
}
